import React from 'react';
import SvgIcon from 'utils/SvgIcon';

const IntegrateIcon = ({ fillColor, hoverFill, style }) => (
  <SvgIcon
    {...{ fillColor, hoverFill, style }}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.1894 6.00003L12.757 6.00002C11.2419 6.01413 10.6271 6.66181 9.63673 8.82292C9.52544 9.06639 9.46625 9.19572 9.41084 9.31544C8.08193 12.1867 6.72278 13.4543 3.75 13.5001H2.25V12.0001L3.73842 12.0001C5.99834 11.9653 6.93649 11.0903 8.04957 8.68541C8.10341 8.56908 8.161 8.44325 8.2731 8.19801C9.48282 5.55825 10.4671 4.52128 12.75 4.50006H13.1893L12.2197 3.53039L13.2803 2.46973L16.0607 5.25006L13.2803 8.03039L12.2197 6.96973L13.1894 6.00003ZM13.1893 13.5001H12.75C11.3003 13.4866 10.3742 13.0635 9.58161 12.0804C9.87588 11.6573 10.1521 11.1878 10.4182 10.6714C11.0485 11.6549 11.6718 11.99 12.757 12.0001L13.1894 12.0001L12.2197 11.0304L13.2803 9.96973L16.0607 12.7501L13.2803 15.5304L12.2197 14.4697L13.1893 13.5001ZM3.73842 5.99997C5.2666 6.02356 6.19039 6.43126 6.97257 7.43642C7.21841 6.90785 7.46279 6.42936 7.71481 5.99945C6.7485 4.99955 5.54263 4.52768 3.75 4.50006H2.25V6.00006L3.73842 5.99997Z"
    />
  </SvgIcon>
);

export default IntegrateIcon;
